(function () {
  'use strict';

  var root = document.documentElement;
  var announce = document.getElementById('vv-a11y-status');
  function say(msg) { if (announce) announce.textContent = msg; }

  /* ---------------------------------------------------------------------
     Theme switcher (dark default, light alternate, persisted)
     ------------------------------------------------------------------- */
  function setThemeMode(mode) {
    root.setAttribute('data-theme-mode', mode);
    try { localStorage.setItem('vv-theme', mode); } catch (e) {}
    document.querySelectorAll('[data-theme-toggle]').forEach(function (group) {
      group.querySelectorAll('button').forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-mode') === mode ? 'true' : 'false');
      });
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-theme-toggle] button');
    if (!btn) return;
    setThemeMode(btn.getAttribute('data-mode'));
  });
  document.addEventListener('DOMContentLoaded', function () {
    setThemeMode(root.getAttribute('data-theme-mode') || 'dark');
  });

  /* ---------------------------------------------------------------------
     Sticky header
     ------------------------------------------------------------------- */
  var header = document.querySelector('.vv-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 12);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------------------------------------------------------------
     Generic spring-panel controller
     ---------------------------------------------------------------------
     Drives a sliding panel (mobile menu, cart drawer, search overlay) on
     one axis. Before Motion has loaded, open()/close() just flip the
     wrapper's data-open attribute and let the CSS transition in
     theme.css do the work — that CSS transition is the permanent,
     guaranteed fallback for no-JS / blocked-network / reduced-motion.
     Once Motion loads, upgradeToSpring() swaps in real, interruptible
     spring physics (damping ~0.8 / response ~0.3 — Apple's "drawer /
     sheet" preset, see /anthropic-skills:apple-design §4's table): every
     open()/close() call animates from the panel's CURRENT on-screen
     position (never a fixed start value), so clicking open/close
     rapidly, or dragging mid-animation, never pops or jump-cuts. */
  function createPanelController(wrapperEl, panel, axis, closedSign) {
    var springFn = null;
    var activeAnim = null;

    function closedValue() {
      var size = axis === 'x' ? panel.getBoundingClientRect().width : panel.getBoundingClientRect().height;
      return closedSign * size;
    }

    function setState(onOpen) {
      wrapperEl.setAttribute('data-open', onOpen ? 'true' : 'false');
      document.body.style.overflow = onOpen ? 'hidden' : '';
      if (springFn) {
        if (activeAnim && activeAnim.stop) activeAnim.stop();
        activeAnim = springFn(onOpen);
      }
    }

    return {
      open: function () { setState(true); },
      close: function () { setState(false); },
      isOpen: function () { return wrapperEl.getAttribute('data-open') === 'true'; },
      closedValue: closedValue,
      panel: panel,
      axis: axis,
      /* Called once Motion is ready. Seeds Motion's tracked x/y value to
         match whatever the panel's CSS-driven position is RIGHT NOW
         (open or closed — someone may have already toggled it before
         Motion finished loading), with a zero-duration animate() call —
         this is the "always animate from the presentation value" rule
         applied to the handoff moment itself, so the very first spring
         this panel ever runs has the correct starting point instead of
         assuming 0. */
      upgradeToSpring: function (animate) {
        var isOpenNow = wrapperEl.getAttribute('data-open') === 'true';
        var seed = {};
        seed[axis] = isOpenNow ? 0 : closedValue();
        animate(panel, seed, { duration: 0 });
        springFn = function (onOpen) {
          var kf = {};
          kf[axis] = onOpen ? 0 : closedValue();
          var opts = { type: 'spring', bounce: 0.2, duration: 0.3 };
          var v = panel.__vvReleaseVelocity;
          if (v) { opts.velocity = v; panel.__vvReleaseVelocity = 0; }
          return animate(panel, kf, opts);
        };
      },
      setReleaseVelocity: function (v) { panel.__vvReleaseVelocity = v; }
    };
  }

  /* ---------------------------------------------------------------------
     Mobile menu
     ------------------------------------------------------------------- */
  var mobileMenuWrap = document.querySelector('.vv-mobile-menu');
  var mobileMenuPanel = mobileMenuWrap ? mobileMenuWrap.querySelector('.vv-mobile-menu__panel') : null;
  var mobileMenuCtrl = mobileMenuPanel ? createPanelController(mobileMenuWrap, mobileMenuPanel, 'x', -1) : null;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mobile-menu-open]')) {
      if (mobileMenuCtrl) mobileMenuCtrl.open();
    }
    if (e.target.closest('[data-mobile-menu-close]')) {
      if (mobileMenuCtrl) mobileMenuCtrl.close();
    }
  });

  /* ---------------------------------------------------------------------
     Product shelf — horizontal scroll arrow buttons
     ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var prevBtn = e.target.closest('[data-shelf-prev]');
    var nextBtn = e.target.closest('[data-shelf-next]');
    if (!prevBtn && !nextBtn) return;
    var wrap = (prevBtn || nextBtn).closest('[data-shelf-wrap]');
    var shelf = wrap ? wrap.querySelector('[data-shelf]') : null;
    if (!shelf) return;
    var amount = Math.min(shelf.clientWidth * 0.85, 640);
    shelf.scrollBy({ left: prevBtn ? -amount : amount, behavior: 'smooth' });
  });

  /* ---------------------------------------------------------------------
     Accordions
     ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.vv-accordion__trigger');
    if (!trigger) return;
    var accordion = trigger.closest('.vv-accordion');
    var panel = accordion.querySelector('.vv-accordion__panel');
    var isOpen = accordion.getAttribute('data-open') === 'true';
    accordion.setAttribute('data-open', isOpen ? 'false' : 'true');
    trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (window.__vvAnimateAccordion) {
      window.__vvAnimateAccordion(panel, !isOpen);
    } else {
      panel.style.maxHeight = isOpen ? null : panel.scrollHeight + 'px';
    }
  });

  /* ---------------------------------------------------------------------
     Fade-in on scroll
     ------------------------------------------------------------------- */
  var io;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.vv-fade-in').forEach(function (el) { io.observe(el); });
    });
  }

  /* ---------------------------------------------------------------------
     Cart drawer (AJAX Cart API)
     ------------------------------------------------------------------- */
  var cartDrawer = document.querySelector('.vv-cart-drawer');
  var cartDrawerPanel = cartDrawer ? cartDrawer.querySelector('.vv-cart-drawer__panel') : null;
  var cartDrawerCtrl = cartDrawerPanel ? createPanelController(cartDrawer, cartDrawerPanel, 'x', 1) : null;

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  /* Cart-count badge: text + visibility together, in one place, so every
     caller (full re-render, optimistic bump, rollback) stays consistent —
     empty cart shows the bare icon, no "0" badge. */
  function setCartCountEls(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function renderCart(cart) {
    if (!cartDrawer) return;
    var itemsEl = cartDrawer.querySelector('.vv-cart-drawer__items');
    var subtotalEl = cartDrawer.querySelector('[data-cart-subtotal]');
    var drawerCountEl = cartDrawer.querySelector('[data-cart-drawer-count]');
    if (drawerCountEl) drawerCountEl.textContent = cart.item_count;
    setCartCountEls(cart.item_count);

    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="vv-cart-drawer__empty">Your bag is empty.</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function (item) {
        return '' +
          '<div class="vv-cart-line" data-key="' + item.key + '">' +
            '<div class="vv-cart-line__media"><img src="' + (item.image || '') + '" alt="' + item.product_title + '" loading="lazy"></div>' +
            '<div>' +
              '<div class="vv-cart-line__title">' + item.product_title + '</div>' +
              (item.variant_title ? '<div class="vv-cart-line__variant">' + item.variant_title + '</div>' : '') +
              '<div class="vv-qty-stepper" data-cart-qty>' +
                '<button type="button" data-qty-step="down" aria-label="Decrease quantity">−</button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" data-qty-step="up" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<button type="button" class="vv-cart-line__remove" data-cart-remove>Remove</button>' +
            '</div>' +
            '<div class="vv-cart-line__price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>';
      }).join('');
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateShippingBar(cart);
  }

  function updateShippingBar(cart) {
    var bar = cartDrawer ? cartDrawer.querySelector('[data-shipping-bar]') : null;
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold-cents'), 10);
    if (!threshold) return;
    var textEl = bar.querySelector('[data-shipping-bar-text]');
    var fillEl = bar.querySelector('[data-shipping-bar-fill]');
    var remaining = threshold - cart.total_price;
    var pct = Math.min(100, (cart.total_price / threshold) * 100);
    if (fillEl) fillEl.style.width = pct + '%';
    if (textEl) {
      if (remaining > 0) {
        textEl.innerHTML = 'Add ' + formatMoney(remaining) + ' more for free delivery';
        bar.classList.remove('is-unlocked');
      } else {
        textEl.innerHTML = '<i class="fa-solid fa-check" aria-hidden="true"></i> Free delivery unlocked';
        if (!bar.classList.contains('is-unlocked')) {
          bar.classList.add('is-unlocked');
          if (window.__vvMotion) {
            window.__vvMotion.animate(fillEl, { transform: ['scaleY(1)', 'scaleY(1.6)', 'scaleY(1)'] }, { duration: 0.4 });
          }
        }
      }
    }
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active + ' ' : 'AED ') + amount;
  }

  function openCartDrawer(options) {
    if (!cartDrawer) return;
    if (cartDrawerCtrl) { cartDrawerCtrl.open(); } else { cartDrawer.setAttribute('data-open', 'true'); document.body.style.overflow = 'hidden'; }
    if (!(options && options.skipFetch)) {
      fetchCart().then(renderCart);
    }
  }

  function setCartLoading(isLoading) {
    if (!cartDrawer) return;
    var itemsEl = cartDrawer.querySelector('.vv-cart-drawer__items');
    if (itemsEl) itemsEl.style.opacity = isLoading ? '.45' : '';
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    if (cartDrawerCtrl) { cartDrawerCtrl.close(); } else { cartDrawer.setAttribute('data-open', 'false'); document.body.style.overflow = ''; }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCartDrawer(); }
    if (e.target.closest('[data-cart-close]')) { closeCartDrawer(); }
  });

  /* ---------------------------------------------------------------------
     Cart drawer — drag-to-dismiss (the single highest-impact gesture
     upgrade per the Apple design pass). Grabbed from the drawer's head
     bar (not the scrollable item list, so it never fights a content
     scroll, and not the close button itself). Tracks the pointer 1:1
     with setPointerCapture, rubber-bands if dragged past fully-open,
     and on release projects momentum forward (Apple's exponential decay
     formula) to decide snap-closed vs snap-back-open, handing the
     release velocity to the spring so there's no seam between the drag
     and the animation that finishes it. See /anthropic-skills:apple-design
     §2, §5, §6, §9. */
  (function setupCartDrawerDrag() {
    if (!cartDrawerCtrl || !cartDrawerPanel) return;
    var handle = cartDrawer.querySelector('.vv-cart-drawer__head');
    if (!handle) return;
    var panel = cartDrawerPanel;
    var dragging = false;
    var pointerId = null;
    var startClientX = 0;
    var startPanelX = 0;
    var history = [];

    function currentX() {
      var m = getComputedStyle(panel).transform;
      if (!m || m === 'none') return 0;
      var match = m.match(/matrix\(([^)]+)\)/);
      if (!match) return 0;
      var parts = match[1].split(',').map(function (n) { return parseFloat(n); });
      return parts[4] || 0;
    }

    function rubberband(overshoot, dim, c) {
      c = c || 0.55;
      return (overshoot * dim * c) / (dim + c * Math.abs(overshoot));
    }

    handle.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button, a, input')) return;
      dragging = true;
      pointerId = e.pointerId;
      try { handle.setPointerCapture(pointerId); } catch (err) {}
      startClientX = e.clientX;
      startPanelX = currentX();
      history = [{ x: e.clientX, t: e.timeStamp }];
      panel.style.transition = 'none';
    });

    handle.addEventListener('pointermove', function (e) {
      if (!dragging || e.pointerId !== pointerId) return;
      var dx = e.clientX - startClientX;
      var next = startPanelX + dx;
      var width = panel.getBoundingClientRect().width;
      if (next < 0) next = rubberband(next, width);
      panel.style.transform = 'translateX(' + next + 'px)';
      history.push({ x: e.clientX, t: e.timeStamp });
      if (history.length > 6) history.shift();
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      try { handle.releasePointerCapture(pointerId); } catch (err) {}
      var width = panel.getBoundingClientRect().width;
      var last = history[history.length - 1] || { x: e.clientX, t: e.timeStamp };
      var first = history[0] || last;
      var dt = (last.t - first.t) / 1000;
      var velocity = dt > 0 ? (last.x - first.x) / dt : 0; /* px/s, positive = toward closed */
      var current = currentX();
      var projected = current + (velocity / 1000) * 0.998 / (1 - 0.998); /* Apple's momentum-projection decay */
      var shouldClose = projected > width * 0.4 || velocity > 500;
      panel.style.transform = '';
      panel.style.transition = '';
      if (cartDrawerCtrl) cartDrawerCtrl.setReleaseVelocity(velocity);
      if (shouldClose) { closeCartDrawer(); } else if (cartDrawerCtrl) { cartDrawerCtrl.open(); }
    }

    handle.addEventListener('pointerup', endDrag);
    handle.addEventListener('pointercancel', endDrag);
  })();

  /* Add to cart (product form + quick add)

     Optimistic: the drawer opens and the cart-count badge bumps
     the instant you click — before either network call finishes —
     instead of waiting on /cart/add.js then a separate /cart.js
     fetch to learn the real totals. The real cart still overwrites
     these guesses moments later; on failure the count is rolled
     back and say() reports the failure. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-atc-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
    }

    var formData = new FormData(form);
    var optimisticQty = parseInt(formData.get('quantity'), 10) || 1;
    var previousCount = 0;
    var firstCountEl = document.querySelector('[data-cart-count]');
    if (firstCountEl) previousCount = parseInt(firstCountEl.textContent, 10) || 0;
    setCartCountEls(previousCount + optimisticQty);

    openCartDrawer({ skipFetch: true });
    setCartLoading(true);

    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        say('Added to bag');
        return fetchCart();
      })
      .then(function (cart) {
        renderCart(cart);
      })
      .catch(function () {
        say('Could not add item to bag');
        setCartCountEls(previousCount);
      })
      .then(function () {
        setCartLoading(false);
        if (btn) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
        }
      });
  });

  /* Remove line item — dims the line immediately so it feels instant;
     the real re-render below then confirms it for good. */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;
    var line = removeBtn.closest('.vv-cart-line');
    var key = line.getAttribute('data-key');
    line.style.opacity = '.35';
    line.style.pointerEvents = 'none';
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  /* Cart line qty change — updates the visible number immediately,
     before the network call, then the real re-render confirms it. */
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('.vv-cart-line [data-qty-step]');
    if (!stepBtn) return;
    var line = stepBtn.closest('.vv-cart-line');
    var key = line.getAttribute('data-key');
    var span = line.querySelector('.vv-qty-stepper span');
    var qty = parseInt(span.textContent, 10);
    qty = stepBtn.getAttribute('data-qty-step') === 'up' ? qty + 1 : Math.max(0, qty - 1);
    span.textContent = qty;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  document.addEventListener('DOMContentLoaded', function () { fetchCart().then(renderCart); });

  /* Quantity steppers that use a plain <input> instead of the drawer's <span> —
     the product page and the full cart page. Deliberately excludes anything
     inside .vv-cart-line so it never double-handles the drawer's AJAX buttons above. */
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-step]');
    if (!stepBtn || stepBtn.closest('.vv-cart-line')) return;
    var wrap = stepBtn.closest('.vv-qty-stepper');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;
    var qty = parseInt(input.value, 10);
    if (isNaN(qty)) qty = min;
    qty = stepBtn.getAttribute('data-qty-step') === 'up' ? qty + 1 : Math.max(min, qty - 1);
    input.value = qty;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Cart PAGE quantity steppers — adjusts the number input only; the page's own
     "Update Bag" button submits everything together via a normal form POST. */
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('.vv-cart-line [data-page-qty-step]');
    if (!stepBtn) return;
    var wrap = stepBtn.closest('.vv-qty-stepper');
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var qty = parseInt(input.value, 10) || 0;
    qty = stepBtn.getAttribute('data-page-qty-step') === 'up' ? qty + 1 : Math.max(0, qty - 1);
    input.value = qty;
  });

  /* ---------------------------------------------------------------------
     Predictive search
     ------------------------------------------------------------------- */
  var searchOverlay = document.querySelector('.vv-search-overlay');
  var searchOverlayPanel = searchOverlay ? searchOverlay.querySelector('.vv-search-overlay__panel') : null;
  var searchOverlayCtrl = searchOverlayPanel ? createPanelController(searchOverlay, searchOverlayPanel, 'y', -1) : null;
  var searchInput = searchOverlay ? searchOverlay.querySelector('input[type="search"]') : null;
  var searchResults = searchOverlay ? searchOverlay.querySelector('.vv-search-results') : null;
  var searchDebounce;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) {
      e.preventDefault();
      if (searchOverlayCtrl) { searchOverlayCtrl.open(); } else { searchOverlay.setAttribute('data-open', 'true'); document.body.style.overflow = 'hidden'; }
      setTimeout(function () { searchInput && searchInput.focus(); }, 100);
    }
    if (e.target.closest('[data-search-close]')) {
      if (searchOverlayCtrl) { searchOverlayCtrl.close(); } else { searchOverlay.setAttribute('data-open', 'false'); document.body.style.overflow = ''; }
    }
  });

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounce);
      var q = searchInput.value.trim();
      if (!q) { searchResults.innerHTML = ''; return; }
      searchDebounce = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][fields]=title,product_type,vendor')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            searchResults.innerHTML = products.map(function (p) {
              return '' +
                '<a href="' + p.url + '" class="vv-card">' +
                  '<div class="vv-card__media"><img src="' + (p.image || '') + '" alt="' + p.title + '" loading="lazy"></div>' +
                  '<div class="vv-card__name">' + p.title + '</div>' +
                  '<div class="vv-card__price">' + p.price + '</div>' +
                '</a>';
            }).join('');
          });
      }, 220);
    });
  }

  /* ---------------------------------------------------------------------
     Live search suggestions — header search inputs
     Attaches typeahead to whichever header search inputs exist on this
     page (desktop inline bar, desktop icon dropdown, mobile panel).
     Pure JS — no markup changes needed in header.liquid. Debounced
     (300ms "wait"), reuses the same /search/suggest.json endpoint as
     the full-screen overlay above.
     ------------------------------------------------------------------- */
  (function () {
    var suggestBoxes = new WeakMap();

    function getOrCreateBox(input) {
      if (suggestBoxes.has(input)) return suggestBoxes.get(input);
      var box = document.createElement('div');
      box.className = 'vv-search-suggest';
      box.setAttribute('role', 'listbox');
      input.insertAdjacentElement('afterend', box);
      var parent = input.parentElement;
      if (parent && getComputedStyle(parent).position === 'static') {
        parent.style.position = 'relative';
      }
      suggestBoxes.set(input, box);
      return box;
    }

    function renderSuggestions(box, products) {
      if (!products.length) {
        box.innerHTML = '';
        box.classList.remove('is-open');
        return;
      }
      box.innerHTML = products.map(function (p) {
        return '' +
          '<a href="' + p.url + '" class="vv-search-suggest__item">' +
            (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
            '<span class="vv-search-suggest__title">' + p.title + '</span>' +
            '<span class="vv-search-suggest__price">' + p.price + '</span>' +
          '</a>';
      }).join('');
      box.classList.add('is-open');
    }

    function attachTypeahead(input) {
      if (!input || input.dataset.vvTypeahead === 'true') return;
      input.dataset.vvTypeahead = 'true';
      var box = getOrCreateBox(input);
      var timer;

      input.addEventListener('input', function () {
        clearTimeout(timer);
        var q = input.value.trim();
        if (q.length < 2) {
          box.innerHTML = '';
          box.classList.remove('is-open');
          return;
        }
        timer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,vendor')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              renderSuggestions(box, products);
            })
            .catch(function () {});
        }, 300);
      });

      input.addEventListener('focus', function () {
        if (box.innerHTML) box.classList.add('is-open');
      });

      input.addEventListener('blur', function () {
        setTimeout(function () { box.classList.remove('is-open'); }, 150);
      });
    }

    function attachAll() {
      var byId = ['vv-searchbar-input', 'vv-search-dropdown-input'];
      byId.forEach(function (id) {
        var el = document.getElementById(id);
        if (el) attachTypeahead(el);
      });
      var mobileInput = document.querySelector('[data-mobile-search-input]');
      if (mobileInput) attachTypeahead(mobileInput);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', attachAll);
    } else {
      attachAll();
    }
  })();

  /* ---------------------------------------------------------------------
     Auth pages — forgot-password toggle
     ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-auth-toggle-recover]');
    if (!toggle) return;
    var panel = document.getElementById('RecoverPassword');
    if (!panel) return;
    var hidden = panel.hasAttribute('hidden');
    if (hidden) { panel.removeAttribute('hidden'); } else { panel.setAttribute('hidden', ''); }
  });

  /* ---------------------------------------------------------------------
     Address forms — country / province selectors + edit toggles
     Every country option from {{ form.country_option_tags }} carries a
     data-provinces attribute (a JSON array Shopify renders automatically).
     This reads that JSON and keeps a matching province <select> in sync —
     falling back to a plain text field for countries with no defined
     provinces, so nothing gets stuck unusable.
     ------------------------------------------------------------------- */
  function initCountryProvinceSelector(countrySelect) {
    if (!countrySelect || countrySelect.dataset.vvInit === 'true') return;
    countrySelect.dataset.vvInit = 'true';
    var scope = countrySelect.closest('[data-address-form]') || document;
    var provinceContainer = scope.querySelector('[data-province-container]');
    var provinceSelect = scope.querySelector('[data-province-select]');
    if (!provinceContainer || !provinceSelect) return;

    function render() {
      var selectedOption = countrySelect.options[countrySelect.selectedIndex];
      var provincesRaw = selectedOption ? selectedOption.getAttribute('data-provinces') : null;
      var provinces = [];
      try { provinces = provincesRaw ? JSON.parse(provincesRaw) : []; } catch (err) { provinces = []; }

      if (provinces.length) {
        provinceContainer.hidden = false;
        provinceSelect.innerHTML = provinces.map(function (p) {
          return '<option value="' + p[0] + '">' + p[1] + '</option>';
        }).join('');
        var defaultProvince = provinceSelect.getAttribute('data-default');
        if (defaultProvince) provinceSelect.value = defaultProvince;
      } else {
        provinceContainer.hidden = true;
      }
    }
    countrySelect.addEventListener('change', render);
    render();
  }
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-country-select]').forEach(initCountryProvinceSelector);
  });

  /* Toggle edit/add address panels */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-address-edit-open]');
    if (openBtn) {
      var target = document.getElementById(openBtn.getAttribute('data-address-edit-open'));
      if (target) {
        target.hidden = !target.hidden;
        if (!target.hidden) {
          var cs = target.querySelector('[data-country-select]');
          if (cs) initCountryProvinceSelector(cs);
        }
      }
    }
    var deleteBtn = e.target.closest('[data-address-delete]');
    if (deleteBtn && !confirm('Delete this address?')) {
      e.preventDefault();
    }
  });

  /* ---------------------------------------------------------------------
     Motion (motion.dev) — optional progressive enhancement
     Vanilla "motion" package (~10kb: animate + scroll), CDN-loaded.
     Powers: hero scroll-zoom, smoother accordion open/close, and — new in
     the Apple design pass — real interruptible springs on the mobile
     menu, cart drawer, and search overlay (plus drag-to-dismiss on the
     cart drawer). Everything above already works without this — if it's
     slow to load, blocked by the network, or the visitor prefers reduced
     motion, the CSS transitions and max-height accordion above are the
     real UI.
     ------------------------------------------------------------------- */
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReducedMotion) {
    import('https://cdn.jsdelivr.net/npm/motion@13.1.0/+esm')
      .then(function (Motion) {
        var animate = Motion.animate;
        var scrollFn = Motion.scroll;
        window.__vvMotion = { animate: animate, scroll: scrollFn };

        /* Upgrade the three sliding panels to real springs now that
           Motion is here — see createPanelController() above for what
           this swaps in. */
        [mobileMenuCtrl, cartDrawerCtrl, searchOverlayCtrl].forEach(function (ctrl) {
          if (ctrl) ctrl.upgradeToSpring(animate);
        });

        /* Hero scroll-zoom: the hero image eases from a gentle 6% zoom
           down to its resting scale as the hero itself scrolls past.
           Linked to the hero's own height only — no pinning, no
           scroll-jacking, nothing outside the hero ever moves. */
        var heroSection = document.querySelector('.vv-hero');
        var heroImage = heroSection ? heroSection.querySelector('.vv-hero-full__media img, .vv-hero__media img') : null;
        if (heroImage && scrollFn) {
          scrollFn(
            animate(heroImage, { transform: ['scale(1.06)', 'scale(1)'] }, { easing: 'linear' }),
            { target: heroSection, offset: ['start start', 'end start'] }
          );
        }

        /* Hero headline stagger-in: split into words and ease each one
           up into place on load. Only runs once Motion has confirmed it
           loaded — the heading is real text in the DOM the whole time,
           so nothing is ever hidden if this never fires. */
        document.querySelectorAll('[data-vv-stagger]').forEach(function (heading) {
          var words = heading.textContent.trim().split(/\s+/);
          heading.innerHTML = words.map(function (w) {
            return '<span style="display:inline-block;overflow:hidden;vertical-align:top;"><span style="display:inline-block;" class="vv-stagger-word">' + w + '&nbsp;</span></span>';
          }).join('');
          var spans = heading.querySelectorAll('.vv-stagger-word');
          animate(spans, { transform: ['translateY(110%)', 'translateY(0%)'] }, { duration: 0.7, delay: Motion.stagger ? Motion.stagger(0.05) : 0, easing: [0.16, 1, 0.3, 1] });
        });

        /* Scroll-triggered grid reveals with a light stagger — replaces
           the plain group fade for product/category grids specifically.
           Anything still only wearing .vv-fade-in keeps the CSS/IO
           fallback behaviour defined earlier in this file. */
        document.querySelectorAll('.vv-grid.vv-fade-in, .vv-cat-grid.vv-fade-in').forEach(function (grid) {
          var items = grid.children;
          if (!items.length) return;
          if (grid.classList.contains('is-visible')) return; /* the fast IO fallback above already revealed this one first — leave it alone, no re-animating */
          if (io && io.unobserve) io.unobserve(grid);
          grid.classList.remove('vv-fade-in');
          grid.style.opacity = 1;
          Array.prototype.forEach.call(items, function (item) { item.style.opacity = 0; });
          Motion.inView(grid, function () {
            animate(items, { opacity: [0, 1], transform: ['translateY(16px)', 'translateY(0px)'] },
              { duration: 0.55, delay: Motion.stagger ? Motion.stagger(0.07) : 0, easing: [0.4, 0, 0.2, 1] });
          }, { margin: '0px 0px -10% 0px' });
        });

        /* Smoother accordion: once Motion is available, panels animate
           on measured height instead of the coarser max-height transition. */
        window.__vvAnimateAccordion = function (panel, opening) {
          panel.style.transition = 'none';
          panel.style.maxHeight = 'none';
          if (opening) {
            var target = panel.scrollHeight;
            panel.style.height = '0px';
            animate(panel, { height: [0, target + 'px'] }, { duration: 0.4, easing: [0.4, 0, 0.2, 1] })
              .finished.then(function () { panel.style.height = 'auto'; });
          } else {
            var current = panel.scrollHeight;
            panel.style.height = current + 'px';
            animate(panel, { height: [current + 'px', '0px'] }, { duration: 0.3, easing: [0.4, 0, 0.2, 1] });
          }
        };
      })
      .catch(function () { /* offline or blocked by the network — CSS fallbacks above already cover this */ });
  }
})();
